<template>
  <div v-tooltip.left="tooltipMessage" class="social-step-editor-menu-item">
    <button
      :class="[
        'social-step-editor-menu-item-button',
        {'social-step-editor-menu-item-button--active': active},
        {'social-step-editor-menu-item-button--disabled': disabled},
      ]"
      :disabled="disabled"
      @click="$emit('clicked')"
    >
      <span v-html="item.icon" class="d-flex"></span>
    </button>
  </div>
</template>

<script>
import {socialStepEditorMenuType} from './SocialStepEditorMenuType.js';

export default {
  props: {
    item: Object,
    active: Boolean,
    disabledItems: Array,
  },
  data: () => ({
    menuType: socialStepEditorMenuType,
  }),
  computed: {
    disabled() {
      return this.disabledItems.includes(this.item.name);
    },
    tooltipMessage() {
      if (!this.disabled) return '';
      switch (this.item.name) {
        case this.menuType.Media:
          return 'Sorry, but this social post does not support custom images.';
        case this.menuType.AdvancedMode:
          return 'Please enter Advanced mode';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-menu-item {
  height: 72px;
  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-left: 4px solid transparent;
    background: transparent;
    outline: none;
    cursor: pointer;
    color: $grey-cloud-color;
    transition: all 0.25s;
    border-radius: unset;
    &--disabled {
      pointer-events: none;
    }
    &:hover,
    &--active {
      background: $color-romance;
      color: $black-color;
    }

    &--active {
      border-left: 4px solid $black-color;
      box-shadow: 0px 4px 4px rgba($black-color, 0.15);
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 0.3 !important;
    }
  }
}
</style>
